import { render, staticRenderFns } from "./legalnotice.vue?vue&type=template&id=242a718d&scoped=true&lang=pug&"
var script = {}
import style0 from "./legalnotice.vue?vue&type=style&index=0&id=242a718d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a718d",
  null
  
)

export default component.exports